{
	"action": {
		"add": "Add",
		"cancel": "Cancel",
		"close": "Close",
		"delete": "Delete",
		"edit": "Edit",
		"save": "Save",
		"view": "View",
		"filter": "Filter",
		"clear": "Clear",
		"search": "Search…",
		"select": "Select…",
		"retry": "Retry",
		"generate": "Generate",
		"copy": "Copy",
		"done": "Done",
		"reset": "Reset"
	},
	"state": {
		"loading": "Loading…",
		"noMatches": "No matches",
		"noResults": "No results",
		"optional": "optional"
	},
	"pagination": {
		"label": "Pagination",
		"summary_one": "{{from}}–{{to}} of {{total}} result",
		"summary_other": "{{from}}–{{to}} of {{total}} results",
		"summaryWithNoun": "{{from}}–{{to}} of {{total}} {{noun}}",
		"empty": "No results",
		"emptyWithNoun": "No {{noun}}",
		"rowsPerPage": "Rows per page",
		"firstPage": "First page",
		"previousPage": "Previous page",
		"nextPage": "Next page",
		"lastPage": "Last page",
		"page": "Page {{page}}",
		"showing_one": "Showing {{from}} to {{to}} of {{total}}",
		"showing_other": "Showing {{from}} to {{to}} of {{total}}",
		"perPage": "{{n}} / page",
		"showingNoTotal": "Showing {{from}} to {{to}}"
	},
	"language": {
		"label": "Language",
		"switch": "Change language"
	},
	"dataTable": {
		"action": "Action",
		"errorTitle": "Couldn't load this list",
		"tryAgain": "Try again",
		"emptyTitle": "Nothing here yet",
		"selected": "selected",
		"onOtherPages": "{{n}} on other pages",
		"columns": "Columns",
		"showColumns": "Show columns",
		"always": "always",
		"showAll": "Show all",
		"hiddenCount": "{{n}} hidden",
		"selectRow": "Select row {{row}}",
		"selectAllRows": "Select all rows on this page",
		"deselectAllRows": "Deselect all rows on this page"
	},
	"select": {
		"selectedCount": "{{n}} selected",
		"selectAll": "Select all",
		"removeOption": "Remove {{label}}"
	},
	"filterBar": {
		"label": "Filters"
	},
	"confirmPassword": {
		"label": "Your password",
		"hint": "Confirm it's you — not a misclick.",
		"wrong": "That isn't your password."
	},
	"list": {
		"searchPlaceholder": "Search",
		"search": "Search",
		"clearSearch": "Clear search",
		"sort": "Sort",
		"clearAll": "Clear all",
		"quickFilters": "Quick filters",
		"summary": "Summary"
	},
	"sort": {
		"nameAsc": "Name A–Z",
		"nameDesc": "Name Z–A",
		"newest": "Newest first",
		"oldest": "Oldest first",
		"typeAsc": "Type A–Z",
		"typeDesc": "Type Z–A",
		"codeAsc": "Code A–Z",
		"codeDesc": "Code Z–A"
	},
	"statusGuide": {
		"button": "Statuses",
		"subtitle": "What each status and marker means"
	},
	"calendar": {
		"previousMonth": "Previous month",
		"nextMonth": "Next month",
		"today": "Today",
		"showThem": "Show them"
	},
	"dateInput": {
		"placeholder": "DD/MM/YYYY",
		"pick": "Pick a date"
	},
	"changed": {
		"badge": "Updated",
		"hint": "Someone else changed this since you last opened it.",
		"note": "Updated since you last looked."
	}
}
